const SETTINGS ={
    PRIMARY_COLOR: "#EADDBE",
    SECONDARY_COLOR: "#b77d0c",
    TERTIARY_COLOR: "#f4eedd",
    DEEP_COLOR: "#443621",
    LOGO_COLOR: "#8a0b0b",
    BACKGROUND_COLOR: "#F5F5F5",
    FACEBOOK_LINK: 'https://www.facebook.com/profile.php?id=100089713448848',
    INSTAGRAM_LINK: 'https://www.instagram.com/canadianhantcm/',
    TWITTER_LINK: 'https://twitter.com/canadianhantcm'
}

export default SETTINGS